import React, { memo } from 'react';
import styled from 'styled-components';
import { BaseCard, Row } from '../../styled';
import { DashboardQuery } from 'src/graphql/_generated';
import { Poppins, Spacer } from 'src/common';
import { numeralFormat } from 'src/utils/misc';
import { AssessmentState } from '../types';
import { isEqual } from 'lodash';
import { DangerTooltip } from '../comps';
import { ControlChart } from 'src/components/charts/ControlChart';

const Wrap = styled(BaseCard)`
  position: relative;

  .grid {
    position: relative;
    flex-grow: 1;
    height: 100%;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 10px;

    &__chart {
      position: relative;
      aspect-ratio: 1/1;
      height: 100%;
      max-height: 150px;
      /* width: 100%; */
      overflow: hidden;
      flex-shrink: 0;
      max-width: 100%;

      .highcharts-container {
        width: 100% !important;
        height: 100% !important;
      }
    }

    &__legend {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-bottom: 8px;
    }
  }
`;

interface ControlImplementationV2Props {
  value: DashboardQuery['dashboard']['controlImplementation'];
  state: AssessmentState;
}

export const ControlImplementationV2: React.FC<ControlImplementationV2Props> = memo(({ value, state }) => {
  return (
    <Wrap>
      <span className="c-title">Control Implementation</span>

      {state === 'NO_SCENARIOS' || state === 'SCENARIOS_NO_CONTROLS' ? (
        <>
          <div style={{ flex: 1 }} />
          <DangerTooltip state={state} />
        </>
      ) : (
        <div className="grid">
          <div className="grid__chart">
            <ControlChart value={value} />
          </div>
          <div className="grid__legend">
            <Row>
              <Poppins px={14} weight={500} color="cflowerBlue">
                Not Started ({value?.notStartedCount})
              </Poppins>
              <div className="separator" />
              <Poppins weight={600} color="prussianBlue" px={14}>
                {numeralFormat(value?.notStartedCost)}
              </Poppins>
            </Row>

            <Row>
              <Poppins px={14} weight={500} color="cflowerBlue">
                In Progress ({value?.inProgressCount})
              </Poppins>
              <div className="separator" />
              <Poppins weight={600} color="brightBlue" px={14}>
                {numeralFormat(value?.inProgressCost)}
              </Poppins>
            </Row>

            <Row>
              <Poppins px={14} weight={500} color="cflowerBlue">
                Live ({value?.liveCount})
              </Poppins>
              <div className="separator" />
              <Poppins weight={600} color="gp1" px={14}>
                {numeralFormat(value?.liveCost)}
              </Poppins>
            </Row>

            <Row>
              <Poppins px={14} weight={500} color="cflowerBlue">
                Other ({value?.otherCount})
              </Poppins>
              <div className="separator" />
              <Poppins weight={600} color="cflowerBlue" px={14}>
                {numeralFormat(value?.otherCost)}
              </Poppins>
            </Row>
            <Spacer $px={16} />
            <Row>
              <Poppins px={14} weight={500} color="cflowerBlue">
                Controls without Cost
              </Poppins>
              <div className="separator" />
              <Poppins weight={600} color="prussianBlue" px={14}>
                {value?.controlsWithoutCost}
              </Poppins>
            </Row>
          </div>
        </div>
      )}
    </Wrap>
  );
}, isEqual);
